import JobProfit from "./JobProfit";
import Price from "../common/Price";
import {BillOfMaterialsPreviewItems} from "./BillOfMaterialsPreviewItems";
import {
	BillOfMaterialsPreviewMerchantApiDto,
	BomFinaliseApiDto,
	BomFinalisedCalculationsValuesApiDto,
	BomPreviewDetailsApiDto
} from "../../api/model/rest";
import {none, option, Option} from "ts-option";

/**
 * Detailed bill of materials for selected merchant
 */
export class BillOfMaterialsPreviewDetails {
	constructor(
		public readonly incomplete: boolean,
		public readonly items: BillOfMaterialsPreviewItems,
		public readonly profit: JobProfit,
		public readonly total: Option<Price>,
		public readonly customerPrice: Price,
		public readonly installerEarnings: Price,
		public readonly merchant: BillOfMaterialsPreviewMerchant,
		public readonly partsPriceStrategy: string) {}

	static fromJson(json: BomPreviewDetailsApiDto): BillOfMaterialsPreviewDetails {
		const items = BillOfMaterialsPreviewItems.fromJson(json.items);
		const total = json.total ? option(Price.fromJson(json.total)) : none;
		const customerPrice = Price.fromJson(json.customerPrice);
		const installerEarnings = Price.fromJson(json.installerEarnings);
		return new BillOfMaterialsPreviewDetails(json.incomplete, items, JobProfit.fromJson(json.profit), total, customerPrice,
			installerEarnings, BillOfMaterialsPreviewMerchant.fromJson(json.merchant), json.partsPriceStrategy);
	}

	copy({
		incomplete = this.incomplete,
		items = this.items,
		profit = this.profit,
		total = this.total,
		customerPrice = this.customerPrice,
		installerEarnings = this.installerEarnings,
		merchant = this.merchant,
		partsPriceStrategy = this.partsPriceStrategy
	}) {
		return new BillOfMaterialsPreviewDetails(incomplete, items, profit, total, customerPrice, installerEarnings, merchant,
			partsPriceStrategy);
	}

	fillBasedOnProfit(profit: BillOfMaterialsPreviewDetails) {
		const incomplete = this.items.assets.some(asset => !asset.materials.length)
		return this.copy({incomplete, merchant: profit.merchant});
	}
}

export class BillOfMaterialsPreviewMerchant {
	constructor(
		public readonly  id: string,
		public readonly name: string,
		public readonly preferredBy: Option<string[]>) {}

	static fromJson(json: BillOfMaterialsPreviewMerchantApiDto): BillOfMaterialsPreviewMerchant {
		return new BillOfMaterialsPreviewMerchant(json.id, json.name, option(json.preferredBy));
	}

	copy({preferredBy = this.preferredBy}) {
		return new BillOfMaterialsPreviewMerchant(this.id, this.name, preferredBy)
	}
}

export class BomFinalisedCalculationsValues {
	constructor(
		public readonly customerPrice: Price,
		public readonly installerEarnings: Price) {}

	static fromJson(json: BomFinalisedCalculationsValuesApiDto): BomFinalisedCalculationsValues {
		return new BomFinalisedCalculationsValues(Price.fromJson(json.customerPrice), Price.fromJson(json.installerEarnings));
	}
}

export class BomFinalise {
	constructor(
		public readonly adjustment: string,
		public readonly values: BomFinalisedCalculationsValues) {}

	static fromJson(json: BomFinaliseApiDto): BomFinalise {
		return new BomFinalise(json.adjustment, BomFinalisedCalculationsValues.fromJson(json.values));
	}
}

export enum MerchantPreferredBy {
	HIBER = "HIBER",
	PARTNER_BRAND = "PARTNER_BRAND",
	BOILER = "BOILER"
}
